import "../Leader_Profile/LeaderProfile.scss";
import Lines from '../../components/Lines';

const LeaderProfile = ({ name, education, majorActivities,secondContent, collegeIntro, introTwo, image, designation,  }) => {
  return (
    <article className="leaderProfile">
      <header>
        <h2>{designation}</h2>
      </header>
      <main>
        <section className="first">
          <div className="image-container">
            <img src={image} alt={`Image Of ${name}`} />
            <div className="lines-parent" >
              <Lines color=" #0D553A" count={25} fontSize={2.3} skew={-40} spacing={1} rotateDeg={90} />
            </div>
          </div>
          <div className="content">
            <div className="nameAndEducation">
              <h2>{name}</h2>
              <h3>{education}</h3>
            </div>
            <p>{collegeIntro}</p>
            {
              introTwo && 
              <p>Additionally, an organizational ombudsman offers coaching on ethics and other management issues, provides mediation to facilitate conflict resolution, helps enable safe upward feedback, assists those who feel harassed and discriminated against.</p>
            }
            <div className="lines" style={{ fontFamily: "Arial, Helvetica, sans-serif" }}>
              <Lines color=" #0D553A" count={25} fontSize={2.3} spacing={1} skewParent={-45} />
            </div>
          </div>
        </section>
        <section className="second">
          <h3>Major Activities</h3>
          <ul>
            {majorActivities.map((activity, index) => (
              <li key={index}>{activity}</li>
            ))}
          </ul>
        </section>
            {secondContent && (
                <section className="second">
                    <h3>Ensuring Legal Compliance</h3>
                    <ul>
                      {secondContent.map((activity, index)=>(
                        <li key={index}>{activity}</li>
                        ))}
                    </ul>
                </section>
            )}
      </main>
    </article>
  );
}

export default LeaderProfile;
